const grid = {
    columns: [4, 8, 12],
    gutters: [16, 36, 36],
    margins: [16, 36, 64],
    gaps: 0,
    unit: 'px',
    maxWidth: 1280,
};
export default grid;
//# sourceMappingURL=grid.js.map